const removeParamFromSearchUrl = (search, paramsToRemove) => {
  const searchParams = new URLSearchParams(search);
  paramsToRemove.forEach(p => {
    searchParams.delete(p);
  });
  const startsWithQuestionMark = searchParams.toString().startsWith('?');

  return !startsWithQuestionMark ? `?${searchParams}` : searchParams;
};

export default removeParamFromSearchUrl;
